import React from "react"

import config from 'react-global-configuration';
import styles from '../styles/about.css'
import { HashLink as Link } from 'react-router-hash-link';
import HeaderAll from './parts/HeaderAll'

/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class AboutApp extends React.Component {

  constructor(){
    super()

    this.state = {
      item:null
    }
  }

  componentDidMount(){

  }

  componentWillUnmount(){

  }



  render(){
    // return

    return(
      <div>
      <HeaderAll />
      <main>

        <div className="main-pannel">
          <h1>入会案内</h1>
          <h2>クラブメンバー</h2>
          <p>クラブが開催する様々なアクティビティーに参加することができます。SUP・Yogaなど、どのジャンルでもクラブが開催するアクティテビティーに参加をすることができます。</p>
          <p>そのほか下記の特典があります。
            <ul>
              <li>THE HOUSEグループ 宿泊料金 10%オフ（会員が宿泊代表の時に限る）</li>
              <li>THE HOUSE farm ワンドリンクサービス（会員のみ月1回まで）</li>
              <li>THE HOUSE 主催のイベント割引</li>
              <li>THE HOUSE on the beach 1-2F 冬季の平日デイタイムを30,000円で貸切 (人数は制限があります。)</li>
            </ul>
          </p>
          <h2>料金</h2>
          <p>
            <ul>
              <li>月額料金: 3,000円 </li>
              <li>アクティビティー料金: 各回ごとに異なります。詳細は<Link smooth to="#detail">各アクティビテイー詳細</Link>をご覧ください。</li>
            </ul>
          </p>


          <h2>クラブへの入会</h2>
          <p>クラブへの入会は<Link to="/signup">会員登録</Link>から会員登録をしていただき、月会費支払い用のクレジットカードの登録が完了すると、入会完了です。会員サイトにログインしてアクティビティーのスケジュールなどをご確認いただけます。</p>
          <p className="notice">*クラブへの入会は６ヶ月以上会員になる必要があります</p>

          <h2>お試し入会</h2>
          <p>クラブへの入会をご希望の方は1回に限りお試しでクラブアクティビティーに参加できます。（料金 8,000円）　お申し込みは<Link to="mailto:club@thehousehayama.com">club@thehousehayama.com</Link>までご連絡ください。</p>

          <h2 id="detail">各アクティビティー詳細</h2>
          <table className="club-info">
            <thead>
              <tr><th colSpan="2">SUP</th></tr>
            </thead>
            <tbody>
              <tr>
                <th >詳細</th>
                <td>
                  THE HOUSE SUPクラブから続く人気のアクティビテッィーです。のんびり海上散歩をしたり、ちょっと遠くまで漕いでみたり、レースに出てみたりと、各自が楽しめるスタイルでのSUPを楽しみます。<br/>
                  活動にはスタッフがアテンドしますので、初心者の方からお楽しみいただけます。
                </td>
              </tr>
              <tr><th >開催日</th><td>随時<br/>スタッフのアテンド可能日をカレンダーから選択して参加していただきます。日曜日を中心に活動しますが、土曜日・平日も対応可能です。インストラクターと都合により開催できない日もあります。</td></tr>
              <tr><th >料金</th><td> 5,000円/回<br/>月に2回以上の参加の場合は3,000円/回に割引になります。マイボードを所持している方で何度も楽しみたい方は別途ご相談ください。</td></tr>
              <tr>
                <th >年間イベント<br/>(一部)</th>
                <td>
                  <ul>
                    <li>レース出場（江ノ島・本栖湖・逗子・横浜海の公園など）にチームで参加します。</li>
                    <li>江ノ島遠征：みんなで江ノ島までの片道をのんびり漕いで行きます。</li>
                    <li>本栖湖合宿：7月に希望のメンバーで本栖湖近辺に宿泊してBBQなどをしながらレースにも出場します。レースに参加しないメンバーも合宿だけに参加も可能です。</li>
                    <li>YUKAさんセッション:日本で唯一、世界を転戦する<a href="http://www.supyuka.com/" target="_blank">Yuka</a>さんが帰国するタイミングで特別セッションを行ってくれます。トップパドラーにSUPを教えてもらう貴重な機会です</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <th >その他特典</th>
                <td>
                  <ul>
                    <li>チームキャップなどチームグッズの販売</li>
                    <li>SUP用品などの共同購入</li>
                  </ul>
                </td>
              </tr>
            </tbody>

          </table>
        </div>
      </main>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutApp.js